export { Typography } from './Typography';
export type { TypographyProps } from './Typography';
